import { getAuthHeader } from "../tokenStorage";
import { axiosInstance, noCacheHeaders } from './axiosInstance';

export const getProgramIdeActivitySets = async (payload) => {
  const { programId } = payload;
  return axiosInstance.get(
    `/blapi/ideActivitySets/getProgramIdeActivitySets/${programId}`,
    {
      headers: {
        ...getAuthHeader(),
        ...noCacheHeaders,
      }
    }
  );
};

export const getUserIdeActivitySets = async (payload) => {
  const { programId, userId } = payload;
  return axiosInstance.get(
    `/blapi/ideActivitySets/getUserIdeActivitySets/${programId}/${userId}`,
    {
      headers: {
        ...getAuthHeader(),
        ...noCacheHeaders,
      }
    }
  );
};
